export const getters = {
  getLayers: state => {
    return state.layers
  },
  getDates: state => {
    return state.dates
  },
  getFilteredDates: (state, getters, rootState) => {
    const filters = rootState.geo.projectFilters
    const templateIds = filters?.templateIds
    if (!templateIds || templateIds.length === 0) return state.dates
    return state.dates.filter(d => {
      // dates have id like "template_42" or "radar", extract numeric part
      const match = String(d.id).match(/template_(\d+)/)
      if (!match) return true // keep non-template entries (e.g. radar)
      const id = parseInt(match[1])
      return templateIds.includes(id) || templateIds.includes(String(id))
    })
  },
  getSelectedRange: state => {
    return state.selectedRange
  },
  // New organization layers getters
  getOrgLayers: state => (orgId) => {
    return state.orgLayers[orgId] || []
  },
  getOrgLayerById: state => (orgId, layerId) => {
    const orgLayers = state.orgLayers[orgId] || []
    return orgLayers.find(layer => layer.uuid === layerId)
  },
  getSelectedFeature: state => {
    return state.selectedFeature
  },
  getActiveResult: state => (layerId) => {
    return state.activeResults[layerId] || null
  },
  getSubscriptionResults: state => (orgId, layerCode) => {
    return state.subscriptionResults?.[orgId]?.[layerCode] || null
  },
  getPlanetscopeSelection: state => (layerId) => {
    return state.planetscopeSelection[layerId] || null
  },
  getOrderProductBundle: state => (layerId) => {
    return state.orderProductBundle[layerId] || null
  }
}
